export default __webpack_public_path__ + "9041a2e6e59491896a993a545d1aaabf.png";